<h2 mat-dialog-title class="mat-dialog-title-offset">{{data.feedbackSurvey ? data.feedbackSurvey.feedbackSurveyTitle : data.modalHeader}}</h2>

<div class="modal-close-icon-container tw:flex tw:items-center">
  <button class="close-modal" mat-button [mat-dialog-close]="false" tabindex='-1'>
    <div class="close-modal modal-close-icon">
    </div>
  </button>
</div>

<mat-dialog-content class="mat-typography modal-master-container tw:mx-2">
  <div class="tw:w-full tw:p-4 tw:m-0 tw:mt-2 content-container">

    @if (!submitted && data.feedbackSurvey) {
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:pb-6 tw:content-center tw:justify-center tw:h-full">
        <div class="tw:w-full tw:px-[15px] tw:mb-2">
          <tuition-feedback
            [survey]="data.feedbackSurvey"
            [placementId]="data.placementId"
            [placementStartDate]="data.placementStartDate"
            [placementEndDate]="data.placementEndDate"
            [showHeader]="data.showHeaderText"
            [showSubmit]="false"
          (feedbackSubmitted)="feedbackSubmitted($event)"></tuition-feedback>
        </div>
      </div>
    }
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
      <div class="tw:w-full tw:px-[15px]">
        <thank-you-banner></thank-you-banner>
      </div>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions class="div-flex-buttons">
  @if (!submitted) {
    <div class="div-flex-buttons tw:justify-start tw:items-start">
      <button mat-button [mat-dialog-close]="false" class="btn btn-outline-primary tw:my-1 tw:mx-1 tw:float-left"
      tabindex="-1">{{ data.isManualEntry ? 'Cancel' : 'Remind me later' }}</button>
    </div>
  }
  @if (!submitted) {
    <div class="div-flex-buttons tw:justify-end tw:items-end">
      <button mat-button (click)="studentVoiceHelper.modalSubmit()" class="btn btn-primary tw:my-1 tw:mx-1 tw:float-right"
      [disabled]="studentVoiceHelper.disableModalSubmit">Submit</button>
    </div>
  }
  @if (submitted) {
    <div class="div-flex-buttons tw:justify-end tw:items-end">
      <button mat-button [mat-dialog-close]="false"
      class="btn btn-primary tw:my-1 tw:mx-1 tw:float-right">Close</button>
    </div>
  }
</mat-dialog-actions>